import { useSyncExternalStore } from 'react';

import { createSessionStore } from '@spotify/confidence-flag-evaluation-react';

import { expandAllFlagHighlights } from './collapsedStore';

const FLAG_HIGHLIGHT_KEY = 'devbar-flag-highlight';

const highlightStore = createSessionStore<boolean>({
  key: FLAG_HIGHLIGHT_KEY,
  empty: false,
  parse: raw => raw === 'true',
  serialize: enabled => (enabled ? 'true' : 'false'),
});

export const useFlagHighlightEnabled = (): boolean =>
  useSyncExternalStore(
    highlightStore.subscribe,
    highlightStore.getSnapshot,
    highlightStore.getServerSnapshot,
  );

export const setFlagHighlightEnabled = (enabled: boolean): void => {
  if (!enabled) {
    expandAllFlagHighlights();
  }
  highlightStore.write(enabled);
};
